import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-[5px] w-[74px] shrink-0 rounded-full bg-[#EEF1F4]" }
const _hoisted_2 = { class: "tabular-nums text-[12.5px] font-bold text-gray-900" }

import { indexBgColourClass } from './indexColour';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexGaugeBar',
  props: {
    value: {}
  },
  setup(__props: any) {



// Maps 0 → 0%, 100 → 50%, 200+ → 100% so the centre marker always sits at "on target".
// Clamped at both ends: the live Growth Index is a day-over-day derivation and goes non-physically
// negative when a section is restocked mid-Production Group (observed: -1334), which would otherwise
// produce a negative CSS width. The numeric value beside the bar is still printed as delivered —
// the bar is clamped, the figure is never hidden.
function gaugeWidth(value: number): string {
    return `${Math.min(100, Math.max(0, value / 2))}%`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute left-0 top-0 h-full rounded-full transition-all", _unref(indexBgColourClass)(_ctx.value)]),
        style: _normalizeStyle({ width: gaugeWidth(_ctx.value) })
      }, null, 6),
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "absolute top-0 h-full w-px bg-[#9AA8B5]",
        style: {"left":"50%"}
      }, null, -1))
    ]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.value), 1)
  ], 64))
}
}

})